import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';
import constructionImage from '../Assets/home-img-1.webp';
import WoodImage from '../Assets/Wood-5.jpg';
import RoofImage from '../Assets/Roof-2.jpg';
import KitchenImage from '../Assets/Kitchen-1.webp';
import ServiceCard from './ServiceCard';
import ProjectCard from './ProjectCard';

const Home = () => {
  const services = [
    {
      title: "All Types of Wood & Timber Work",
      description: "Expert craftsmanship in custom woodwork - from structural beams to exquisite finishes that stand the test of time.",
      icon: "🪵"
    },
    {
      title: "Roof Conversions & Extensions",
      description: "Transform your attic into luxury living space or expand your home upwards – seamless designs with weatherproof durability.",
      icon: "🏠"
    },
    {
      title: "Wood Flooring & Cabinets",
      description: "Premium hardwood floors and handcrafted cabinets that blend natural beauty with everyday functionality.",
      icon: "🗄️"
    },
    {
        title: "Doors & Windows",
        description: "High-performance doors and windows designed to enhance security, insulation, and curb appeal.",
        icon: "🚪"
    },
    {
        title: "Double Glaze Doors & Windows",
        description: "Energy-efficient double glazing solutions that cut costs and noise while maximizing comfort year-round.",
        icon: "🪟"
    },
    {
        title: "Professional Kitchen Installation",
        description: "Bespoke kitchen installations where precision engineering meets culinary aesthetics – tailored to your cooking lifestyle.",
        icon: "🔨"
    }
  ];
  const projects = [
    {
      id: 1,
      title: "Wood & Timber Work",
      image: WoodImage
    },
    {
      id: 2,
      title: "Roof Conversions & Extensions",
      image: RoofImage
    },
    {
      id: 3,
      title: "Professional Kitchen Installation",
      image: KitchenImage
    }
  ];

  return (
        <div className="container-fluid">
            <div className="home">
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                <h1>Building Your Vision Into Reality</h1>
                <p>Quality construction services with over 15 years of experience</p>
                <Link to="/contact" className="cta-button">Get a Free Quote</Link>
                </div>
                <div className="hero-image">
                <img src={constructionImage} alt="Construction site" />
                </div>
            </section>
        </div>

            {/* Services Section */}
        <div className="container-fluid"> 
            <div className="second-sec">   
                <section className="services-section">
                    <h2>Our Services</h2>
                    <div className="services-grid">
                    {services.map((service, index) => (
                        <ServiceCard key={index} service={service} />
                    ))}
                    </div>
                </section>
            </div>
        </div>

            {/* Projects Section */}


         <div className="container-fluid">
            <section className="projects-section">
                <h2>Recent Projects</h2>
                <div className="projects-grid">
                {projects.map((project) => (
                    <ProjectCard key={project.id} project={project} />
                ))}
                </div>
            </section>
        </div>

            {/* Testimonials Section */}
        <div className="container">
            <section className="testimonials">
                <h2>What Our Clients Say</h2>
                <div className="testimonial">
                <p>"The service demonstrates exceptional craftsmanship and versatility in handling various woodworking projects. The attention to detail and quality of materials used ensure durable and aesthetically pleasing results. Whether it’s custom carpentry, structural timber work, or bespoke wooden designs, the team exhibits expertise in delivering high-end finishes. Ideal for clients seeking precision and reliability."</p>
                <p className="client-name">- Japjot Singh</p>
                </div>
            </section>
        </div>
    </div>
  );
};

export default Home;

